import { useQuery } from '@tanstack/react-query';
import PosterShowsDisplay from 'components/frontpage/cinemaprogram/PosterShowsDisplay';
import { getProgram } from 'lib/client/movieinfo';
import IProgram, { ICurrentMoviesProgram } from 'lib/types/Program';
import Settings from 'lib/types/Settings';
import { useMemo } from 'react';

//#region [Props]
type SpecialShowsProgramProps = {
	settings: Settings;
	showType: string;
	ediIncludeOnly?: string[];
};
//#endregion

//#region [Component]
export default function SpecialShowsProgram({ settings, showType, ediIncludeOnly }: SpecialShowsProgramProps) {
	const { isLoading, isError, data, error } = useQuery({
		queryKey: ["program-specialshow", showType.trim()], // key
		queryFn: () => getProgram(undefined, undefined, true, undefined, undefined, showType.trim()), // loader function
		refetchOnWindowFocus: false,
		refetchInterval: 600000, // refretch automatically every 10 minutes
		staleTime: 599999,
	} // options
	);

	const programData = useMemo<IProgram | ICurrentMoviesProgram | undefined>(() => {
		if (!data || (ediIncludeOnly?.length ?? 0) === 0) {
			return data;
		}

		return {
			filmwebMovies: data.filmwebMovies,
			fwpakkeArticles: data.fwpakkeArticles,
			shows: (data as IProgram).shows?.filter(s => ediIncludeOnly!.includes(s.movieMainVersionId))
		};

	}, [data, ediIncludeOnly]);

	return <PosterShowsDisplay settings={settings} data={programData as IProgram} error={error} isError={isError} isLoading={isLoading} hideMoreLink showDate showTypeLocation="poster" />
}
//#endregion